import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const SponsorsSection = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const getConferenceIdFromUrl = () => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    return pathParts[pathParts.length - 1];
  };

  useEffect(() => {
    const conferenceId = getConferenceIdFromUrl();

    if (!conferenceId) {
      setError("Conference ID not found in URL");
      setLoading(false);
      return;
    }

    const fetchSponsors = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `https://eventscons.com/eventbackendnew/api/sponsors-logo/${conferenceId}`
        );

        // ✅ API response structure match kiya
        const apiData = res?.data?.data || [];
        const normalizedData = Array.isArray(apiData) ? apiData : [];

        setSponsors(normalizedData.slice(0, 10));
      } catch (err) {
        console.error("Sponsors API error:", err);
        setError("Failed to load sponsors");
      } finally {
        setLoading(false);
      }
    };

    fetchSponsors();
  }, [location.pathname]);

  const getImage = (item) => {
    // ✅ Exact API field + base URL
    const baseUrl = "https://eventscons.com/eventbackendnew/storage/app/";
    const logoPath = item?.sponsor_logo_url;
    
    return logoPath 
      ? `${baseUrl}${logoPath}` 
      : "https://via.placeholder.com/160x100?text=Sponsor";
  };

  const getTitle = (item) => {
    // ✅ Exact API field use kiya
    return item?.sponsor_title || "Sponsor";
  };

  const getBadge = (item) => {
    // ✅ sponsor_title ko badge me use karo
    return item?.sponsor_title || "Sponsor";
  };

  const conferenceId = getConferenceIdFromUrl();

  return (
    <>
      <style>
        {`
          .sponsors-section {
            max-width: 430px;
            margin: 40px auto;
            font-family: Arial, sans-serif;
          }

          .sponsors-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 18px;
          }

          .sponsors-header h2 {
            margin: 0;
            font-size: 20px;
            font-weight: 700;
            color: #111;
          }

          .view-all-btn {
            background: #000;
            color: #fff;
            border: none;
            outline: none;
            border-radius: 30px;
            padding: 10px 22px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
          }

          .divider {
            height: 1px;
            background: #cfcfcf;
            margin-bottom: 28px;
          }

          .sponsors-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 28px 20px;
          }

          .sponsor-card-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .sponsor-card {
            width: 100%;
            height: 140px;
            background: #fff;
            border: 1.5px solid #a1264d;
            border-radius: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 14px;
            box-sizing: border-box;
          }

          .sponsor-logo {
            max-width: 100%;
            max-height: 90px;
            object-fit: contain;
          }

          .sponsor-badge {
            margin-top: -14px;
            background: #b20f3a;
            color: #fff;
            padding: 7px 20px;
            border-radius: 999px;
            font-size: 13px;
            font-weight: 700;
            min-width: 100px;
            text-align: center;
            line-height: 1;
          }

          .status-text {
            text-align: center;
            font-size: 14px;
            color: #444;
            padding: 20px 0;
          }

          .error-text {
            color: red;
          }

          @media (max-width: 480px) {
            .sponsors-section {
              padding: 18px;
            }

            .sponsors-grid {
              gap: 22px 14px;
            }

            .sponsor-card {
              height: 125px;
              padding: 12px;
            }

            .view-all-btn {
              padding: 8px 18px;
              font-size: 13px;
            }

            .sponsor-badge {
              min-width: 88px;
              font-size: 12px;
              padding: 6px 16px;
            }
          }
        `}
      </style>

      <section className="sponsors-section">
        <div className="sponsors-header">
          <h2>SPONSORS</h2>
          <button
            className="view-all-btn"
            onClick={() => navigate(`/conference/sponsors/${conferenceId}`)}
          >
            VIEW ALL
          </button>
        </div>

        <div className="divider" />

        {loading ? (
          <p className="status-text">Loading sponsors...</p>
        ) : error ? (
          <p className="status-text error-text">{error}</p>
        ) : sponsors.length === 0 ? (
          <p className="status-text">No sponsors found.</p>
        ) : (
          <div className="sponsors-grid">
            {sponsors.map((item, index) => (
              <div className="sponsor-card-wrapper" key={item?.id || index}>
                <div className="sponsor-card">
                  <img
                    src={getImage(item)}
                    alt={getTitle(item)}
                    className="sponsor-logo"
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/160x100?text=Sponsor";
                    }}
                  />
                </div>
                <div className="sponsor-badge">
                  {String(getBadge(item) || "Sponsor").toUpperCase()}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </>
  );
};

export default SponsorsSection;